import { combineReducers } from 'redux';
import { reducer as storeCategoryReducer } from './StoreCategory/storeCategorySlice';
import { reducer as recipientReducer } from '../PagoNubeOnboarding/Recipient/recipientSlice';

const PagoNubeOnboardingReducer = combineReducers({
  storeCategory: storeCategoryReducer,
  recipient: recipientReducer,
});

export default PagoNubeOnboardingReducer;
